import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button, Spinner, Table, Alert } from 'react-bootstrap';
// import { useAuth, api } from '../context/AuthContext';
import api from '../api';

const ExpenseList = () => {
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchExpenses = async () => {
      try {
        const res = await api.get('/expenses');
        setExpenses(res.data || []);
      } catch (err) {
        console.error(err);
        setError(err.response?.data?.message || 'Error fetching expenses');
      } finally {
        setLoading(false);
      }
    };

    fetchExpenses();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this expense?')) return;

    try {
      await api.delete(`/expenses/${id}`);
      setExpenses(prev => prev.filter(exp => exp._id !== id));
    } catch (err) {
      console.error(err);
      setError('Error deleting expense');
    }
  };

  const formatCategory = (expense) => {
    if (expense.category === 'others') {
      return expense.name || 'Other Expense';
    }
    return expense.category.replace(/([A-Z])/g, ' $1').toLowerCase();
  };

  return (
    <Container className="my-4">
      <Row className="mb-4">
        <Col>
          <h2 className="text-center">Expense List</h2>
          <div className="d-flex justify-content-end">
            <Link to="/add-expense">
              <Button variant="success">+ Add New Expense</Button>
            </Link>
          </div>
        </Col>
      </Row>

      {error && <Alert variant="danger">{error}</Alert>}

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : expenses.length === 0 ? (
        <Alert variant="info" className="text-center">No expenses recorded yet.</Alert>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Date</th>
              <th>Expense Details</th>
              <th>Amount (Ksh)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {expenses.map(exp => (
              <tr key={exp._id}>
                <td>{new Date(exp.expenseDate).toLocaleDateString()}</td>
                <td className="text-capitalize">
                  {formatCategory(exp)}
                  {exp.category === 'others' && (
                    <div className="text-muted small mt-1">
                      Category: Other
                    </div>
                  )}
                </td>
                <td>Ksh {Number(exp.amount).toFixed(2)}</td>
                <td>
                  <div className="d-flex gap-2">
                    <Button
                      as={Link}
                      to={`/edit-expense/${exp._id}`}
                      variant="outline-primary"
                      size="sm"
                    >
                      <i className="bi bi-pencil-square"></i> Edit
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleDelete(exp._id)}
                    >
                      <i className="bi bi-trash"></i> Delete
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Container>
  );
};

export default ExpenseList;